import { Environment } from "../interfaces/Environment";

function getBaseEnv(baseApi: string): Environment {
  return {
    intervals: {
      logout: 36000,
      timeout: 150000,
    },
    api: {
      url: `${baseApi}`,
    },
    isProduction: true,
    isDevelopment: false,
  };
}

export default getBaseEnv;
